import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AxiosError } from 'axios';
import { Container } from '@mui/material';

import { MyToverRequiredNotice } from 'components/mytover/content/MyToverRequiredNotice';
import { DefaultLayout } from 'components/page/layouts/DefaultLayout';

// Shared by ContentPage (the pretty-address route) and ArticleContainer (its own fetch,
// reached via the id-based /articles/:id routes and /pixie) - both resolve content via
// the same endpoint and the same ArticlePolicy::view split (401 vs 403), so there is one
// place deciding what a refused reader sees, not two that can quietly drift apart.
export function useContentAccessError(error: unknown): ReactNode | null {
  const location = useLocation();
  const status = (error as AxiosError<{ message?: string; error?: string }>)?.response?.status;

  if (status === 401) {
    return <Navigate to="/signin" state={{ from: location, error: { status: 401, variant: 'warning' } }} replace />;
  }

  if (status === 403) {
    // Unlike 401 above, this reader is signed in on their own account, just missing one
    // service - the refusal belongs on the content's own address, in place, not a bounce
    // to a separate generic page (there's nothing to show an anonymous 401 visitor in
    // place, which is why that case still redirects).
    return (
      <DefaultLayout>
        <Container maxWidth="xl">
          <MyToverRequiredNotice />
        </Container>
      </DefaultLayout>
    );
  }

  return null;
}
